import React, { FunctionComponent } from 'react';

// Libs
import { assetMedicalSpecialty } from '@Libs/utils';
import { Link } from 'react-router-dom';

// @Components
import Anchor from '@Components/Utils/Anchor';
import Image from '@Components/Utils/Image';

interface AnchorComponentProps {
    code: string;
    name: string;
    hrefAnchor: any;
    classNameSpan: any;
    classNameImage: any;
    classNameAnchor: any;
    useRouter?: string;
}
const AnchorComponent: FunctionComponent<AnchorComponentProps> = ({ useRouter, hrefAnchor, code, name, classNameAnchor, classNameImage, classNameSpan }) => {
    return (
        <>
            {useRouter ? (
                <Link to={hrefAnchor} className={classNameAnchor}>
                    <Image className={classNameImage} src={assetMedicalSpecialty(code || 'all')} />
                    <span className={classNameSpan}>{name}</span>
                </Link>
            ) : (
                <Anchor href={hrefAnchor} className={classNameAnchor}>
                    <Image className={classNameImage} src={assetMedicalSpecialty(code || 'all')} />

                    <span className={classNameSpan}>{name}</span>
                </Anchor>
            )}
        </>
    );
};
export default AnchorComponent;
